import { Container, SimpleGrid, Title } from '@mantine/core';

import DatePanelConcilines from '../CustomComponents/DatePanelConciliaciones';

const Conciliaciones = () => {
  
  return (
    <>
      <Container
        fluid
        p="md"
        style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginRight: '20px'
        }}
      >
        <Title order={1} style={{ marginBottom: 20 }}>Ejecución Conciliaciones</Title>

        <SimpleGrid cols={{ base: 1, xs: 4 }} style={{ flex: 1 }} spacing="md">
          <DatePanelConcilines />
        </SimpleGrid>
      </Container>
    </>

  );

}

export default Conciliaciones;